import React from "react";
import { Card, Dropdown, Row, Spinner } from "react-bootstrap";

export const SingleCardMetric = ({
  title = "",
  total = null,
  onHandleClick = null,
  cursor = false,
  active = false,
  isLoading = false,
  types = [],
  selectedType,
  onSelectType,
}: any) => {
  const onUpdate = (e: any) => {
    const newType = types.find((t: any) => t.key === e);
    if (onSelectType) {
      onSelectType(newType?.name);
    }
  };

  return (
    <Card
      className={
        active
          ? "bg-light cursor-pointer button button-today-filter w-100 h-100"
          : cursor
            ? "app-light-color cursor-pointer button w-100 h-100"
            : "bg-light w-100 h-100"
      }
      onClick={onHandleClick}
    >
      <Card.Body className="d-flex flex-column justify-content-between">
        <Row className="text-center">
          {types.length > 0 ? (
            <Dropdown>
              <Dropdown.Toggle variant="link" className="metric-dropdown-toggle text-decoration-none w-100 text-wrap p-0 mb-0">
                {selectedType}
              </Dropdown.Toggle>
              <Dropdown.Menu className="z-2">
                {types.map((i: any) => (
                  <Dropdown.Item key={i.key} onClick={() => onUpdate(i.key)}>
                    {i.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <h5 className="app-orange-text p-0">{title}</h5>
          )}
        </Row>
        {isLoading ? (
          <Row className="text-center">
            <text className="mt-2 mb-2">
              <Spinner animation="border" style={{ color: "#F6893D" }} />
            </text>
          </Row>
        ) : (
          <Row className="text-center">
            <h1 className="text-muted">{selectedType ? types.find((t: any) => t.name === selectedType)?.count : total}</h1>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};
